import { render, staticRenderFns } from "./JudgeWriteComponent.vue?vue&type=template&id=5763e326&scoped=true"
import script from "./JudgeWriteComponent.vue?vue&type=script&lang=js"
export * from "./JudgeWriteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5763e326",
  null
  
)

export default component.exports